
export default {
  data() {
    return {
      isSticky: false,
      potentials: [
        {
          icon: require("~/assets/img/icon-satellite.png"),
          alt: "icone yeux etoile",
          title: "+ de 15 000 entreprises",
          text: "propulsées dans leur communication",
        },
        {
          icon: require("~/assets/img/icon-idee.png"),
          alt: "icone ampoule allumé",
          title: "+ de 5 000 sites web",
          text: "conçus par nos équipes de webdesign",
        },
        {
          icon: require("~/assets/img/icon-orbit.png"),
          alt: "icone licorne",
          title: "+ de 100 métiers",
          text: "différents accompagnés chaque jour",
        },
      ],
      testimonials: [
        {
          img: require("~/assets/img/testimonials/testi-y-toitures.png"),
          tags: [0],
          text: "Je suis très content de leurs services. Toujours à l’écoute et prêts à nous aider. Je recommande pour tout développement dans le domaine internet. Merci à toute l’équipe.",
          author: "Yves HUMMEL — Y Toitures",
        },
        {
          img: require("~/assets/img/testimonials/testi-atc-home.jpg"),
          tags: [0, 2],
          text: "Merci à toute l’équipe pour votre réactivité et votre professionnalisme. Merci à Jamel pour son écoute et son accompagnement au sein de nos projets.",
          author: "Adrien ADAM - ATC Home",
        },
        {
          img: require("~/assets/img/testimonials/testi-gt-autos.jpg"),
          tags: [3, 0, 2],
          text: "Cela fait 3 ans que notre société travaille avec ALEO et ils sont toujours aussi sympathiques et professionnels. Nous leur avons confié ce jour notre site internet ainsi que nos cartes de visite et je suis sûre du résultat, il sera parfait.",
          author: "Cindy TABTI - GT AUTOS MOTORCRAFT",
        },
      ],
      faq: [
        {
          question: "Qui peut devenir partenaire ALEO ?",
          answer: `Toutes les entreprises actrices dans la réussite des entrepreneurs peuvent devenir ALEO : experts-comptables, banques, avocats d’affaires, entreprises de domiciliation, etc.<br> Si votre entreprise a pour vocation d’accompagner les entrepreneurs dans la croissance de leur entreprise, vous pouvez devenir partenaire ALEO.`,
          isCollapsed: false,
        },
        {
          question: "Pourquoi devenir partenaire ALEO ?",
          answer: `Devenir partenaire ALEO vous offre la possibilité d’orienter vos clients vers des solutions complémentaires à celles que vous proposez pour leur permettre de se développer rapidement et d’assurer leur croissance.<br> Vous aurez ainsi l’opportunité d’améliorer votre image de marque et de fidéliser vos clients en devenant acteur de leur réussite. <br> Devenir partenaire ALEO vous permet également d’obtenir une rémunération complémentaire intéressante et/ou en offrant des avantages exclusifs à vos clients.
Vous pourrez ainsi leur proposer les meilleures solutions de communication du marché tout en étant rémunéré.<br>
ALEO s’occupe de tous les supports liés aux partenariats (logos, affiches, supports de vente) mais aussi de tout le suivi statistique (lien de tracking, tableau de bord spécifique…).
`,
          isCollapsed: false,
        },
        {
          question: "Comment devenir partenaire ALEO ?",
          answer: `Vous souhaitez devenir partenaire ALEO ? Il vous suffit de remplir le formulaire de contact ci-dessus ! Un de nos responsables de partenariats prendra contact avec vous pour planifier un rendez-vous de découverte.`,
          isCollapsed: false,
        },
        {
          question: "Qu’est-ce que cela apportera à mes clients ?",
          answer: `En devenant partenaire ALEO, vous offrez à vos clients la possibilité de bénéficier de toutes nos offres à des tarifs préférentiels sans investissement initial. <br>
Vous pourrez leur apporter plus de client, plus de visibilité et donc plus de chiffre d’affaires avec des stratégies de communication gérées de A à Z par une équipe de près de 160 experts.
`,
          isCollapsed: false,
        },
        {
          question: "Que proposez-vous chez ALEO ?",
          answer: `Chez ALEO, nous proposons tous les outils de communication nécessaires au bon développement de l’activité des entrepreneurs. <br>
Sites internet, référencement Google, publicité sur Google, posts sponsorisés sur les réseaux sociaux, logos, flyers et cartes de visites. <br>
Nous offrons aux entrepreneurs la possibilité d’avoir accès au meilleur de la communication grâce à des offres accessibles, clés en main et adaptées à chaque activité.
`,
          isCollapsed: false,
        },
      ],
      offerItems: [
        {
          title: "Site web",
          price: "49€",
          perMonth: true,
          text: `Clé en main. Hébergement, maintenance et stratégie SEO compris dans l’abonnement.`,
          link: "web",
          img: "offer-web.webp",
          alt: "Exemple de site internet",
        },
        {
          title: "Réseaux sociaux",
          price: "290€",
          perMonth: true,
          text: `Publications sponsorisées sur les réseaux sociaux. Budget publicitaire inclus dans l’offre.`,
          link: "gestion-rs",
          img: "offer-cm.png",
          alt: "Exemples de posts Facebook ou Instagram",
        },
        {
          title: "Publicité Google",
          price: "299€",
          perMonth: true,
          text: `Référencement payant (SEA) sur Google. Budget publicitaire inclus dans l’offre.`,
          link: "seo",
          img: "offer-seo.webp",
          alt: "Landing page campagne Google Ads",
        },
        {
          title: "Graphisme",
          price: "199€",
          perMonth: false,
          text: `Création de logos, cartes de visite, flyers, dépliants et plaquettes.`,
          link: "graphism",
          img: "offer-graphism.webp",
          alt: "Exemple de cartes de visite et logo ALEO",
        },
      ],
    };
  },

  head() {
    return {
      title: "ALEO - la solution pour une image pro",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Démarre ton activité avec les outils essentiels à ta réussite !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "ALEO - la solution pour une image pro",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Démarre ton activité avec les outils essentiels à ta réussite !",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: require("~/assets/img/og/og-facebook-graphisme.jpg"),
        },
      ],
    };
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.fadeEffect();
    this.heroAnimation();
  },
  methods: {
    onScroll(e) {
      const header = this.$refs.header;
      const sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },

    fadeEffect() {
      const allElements = [".fade-effect-2"];
      allElements.forEach((item) => {
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: item,
              start: "top 80%",
            },
          })
          .fromTo(
            item,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              stagger: 0.3,
            }
          );
      });
    },

    heroAnimation() {
      const mm = this.$gsap.matchMedia();
      mm.add(
        {
          isDesktop: "(min-width: 1024px)",
          isMobileTablet: "(max-width: 1023px)",
        },
        (context) => {
          const { isDesktop } = context.conditions;
          this.$gsap.timeline().fromTo(
            ".text-hero",
            {
              opacity: 0,
              x: isDesktop ? "20%" : 0,
            },
            {
              opacity: 1,
              x: 0,
              duration: 1,
            }
          );
        }
      );
    },

    scrollSmooth() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "unset";
      }, 1000);
    },
  },
};
